// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.ready",
    name: "Ready",
    homepage: "https://ready.io/",
    image_id: "00ba080d-fb0a-4a31-940e-f75388500500",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/ready-next-gen-messenger/id1668536401",
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "readywallet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map